(function($, undefined) {
  'use strict';
	var doc = $(document);
	var currPage;
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var utils;

	var validateForm = function (ctn) {
		ctn.each(function () {
			var t = $(this);
			var toValidateItems = $('.mentoring-sponsored-input:not(.no-check), .mentoring-sponsored-select-multiple-input', t);
			var toValidateCheck = $('.mentoring-sponsored-check-input.required', t);
			var email = $('.js-email', t);
			var emailConfirm = $('.js-email-confirm', t);
			var btn = $('.js-form-btn', t);
			var isOk = true;
			var checkOk = true;
			var emailOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', t);

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild);
				if (tChild.hasClass('form-error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.mentoring-sponsored-checkbox-ctn');
				var tName = toValidateCheck.attr('name');
				var tParent = t.closest(tCheck.attr('data-validator-apply-class-on'));
				
				if ($('input[name="'+tName+'"]:checked', t).length == 0) {
					tCtn.add(tParent).addClass('form-error');
					checkOk = false;
				} else {
					tCtn.add(tParent).removeClass('form-error');
				}
			});
			
			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				var emailParent = email.closest(email.attr('data-validator-apply-class-on'));
				var emailConfirmParent = emailConfirm.closest(emailConfirm.attr('data-validator-apply-class-on'));
				
				if (email.val().length === 0) {
					email.add(emailParent).removeClass('form-success').addClass('form-error');
					emailOk = false;
				} else {
					email.add(emailParent).addClass('form-success').removeClass('form-error');
					emailOk = true;
				}
                
				if (email.val() !== emailConfirm.val() || (email.val().length === 0)) {
					emailConfirm.add(emailConfirmParent).removeClass('form-success').addClass('form-error');
					emailOk = false;
				} else {
					emailConfirm.add(emailConfirmParent).removeClass('form-error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.add(emailConfirmParent).addClass('form-success');
					}
				}
			}
						
			t.addClass('is-checked');
			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}

			if (!isOk || !checkOk || !emailOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error');

				return true;
			}
		});
	};

	var validateField = function (elt) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.val();
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var emailValid = true;
		var whiteSpaceValid = true;
		var urlValid = true;
		var telValid = true;
		var inputValid = true;

		if(!val.replace(/\s/g, '').length) {
			whiteSpaceValid = false;
		}

		if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.add(elt).hasClass('required') && elt.val() !== '') {
				classTarget.add(elt).removeClass('form-error').addClass('form-success');
			} else {
				classTarget.add(elt).addClass('form-error').removeClass('form-success');
			}
		} else {
			classTarget.add(elt).addClass('form-success').removeClass('form-error');
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.add(elt).removeClass('form-success').addClass('form-error');
								inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.add(elt).removeClass('form-success').removeClass('form-error');
			}
		}

		if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid) {
			classTarget.add(elt).removeClass('form-error').addClass('form-success');
		} else if (val.length === 0 && !classTarget.hasClass('required')) {
			classTarget.add(elt).removeClass('form-error').removeClass('form-success');
		} else {
			classTarget.add(elt).addClass('form-error').removeClass('form-success');
		}
	};

	var init = function () {
		body = $('body');
		utils = Fw.component.models().utils;
		
		$('.mentoring-sponsored-step-testimonials-slider').slick({
			slide: '.mentoring-sponsored-step-testimonials-slide',
			prevArrow: '.mentoring-sponsored-step-testimonials-slider-nav.prev',
			nextArrow: '.mentoring-sponsored-step-testimonials-slider-nav.next',
			infinite: true
		});

		$('.mentoring-question-answer-btn').click(function () {
			var t = $(this);
			var ctn = t.closest('.mentoring-question-answer');
			$('.mentoring-question-answer-btn', ctn).removeClass('selected form-error');
			t.addClass('selected');
		});

		$('.mentoring-sponsored-presentation-specs-content-nav-item').click(function () {
			var t = $(this);
			var id = t.attr('data-id');
			var ctn = t.closest('.mentoring-sponsored-presentation-specs-ctn');
			$('.mentoring-sponsored-presentation-specs-content-nav-item, .mentoring-sponsored-presentation-specs-content-item', ctn).removeClass('selected');
			t.addClass('selected');
			$('.mentoring-sponsored-presentation-specs-content-item[data-id="'+id+'"]').addClass('selected');
		});
		
		$('.mentoring-sponsored-select-multiple-content .mentoring-sponsored-select').change(function () {
			var t = $(this);
			var ctn = t.closest('.mentoring-sponsored-select-multiple');
			var sel = t.find(':selected');
			var newElt = $('.mentoring-sponsored-select-multiple-item.clone', ctn).clone().removeClass('clone');
			var list = $('.mentoring-sponsored-select-multiple-item-list', ctn);
			
			if (sel.text().length !== 0) {
				$('span', newElt).text(sel.text());
				newElt.attr('data-val', sel.attr('value'));
				
				list.append(newElt);
				sel.hide();
				t.val('');
			}
			
			var newValue = '';
			$('.mentoring-sponsored-select-multiple-item:not(.clone)', ctn).each(function (i) {
				if (i !== 0) {
					newValue += ',';
				}
				
				newValue += $(this).attr('data-val');	
			});
			
			$('.mentoring-sponsored-select-multiple-input', ctn).val(newValue);
		});
		
		$('.mentoring-sponsored-select-multiple-content').on('click', '.mentoring-sponsored-select-multiple-item-del', function () {
			var t = $(this);
			var item = t.closest('.mentoring-sponsored-select-multiple-item');
			var ctn = item.closest('.mentoring-sponsored-select-multiple-content');
			var ctnBig = item.closest('.mentoring-sponsored-select-multiple');
			var value = item.attr('data-val');
			
			$('option[value="'+value+'"]').show();
			item.remove();
			
			var newValue = '';
			$('.mentoring-sponsored-select-multiple-item:not(.clone)', ctn).each(function (i) {
				if (i !== 0) {
					newValue += ',';
				}
				newValue += $(this).attr('data-val');	
			});
			
			$('.mentoring-sponsored-select-multiple-input', ctnBig).val(newValue);
		});
			
		$('.mentoring-form-btn').click(function () {
			var form = $(this).closest('.mentoring-form');
			
			validateForm(form);
			
			if (!form.hasClass('has-error')) {
				$('.mentoring-form-error-msg', form).slideUp(200);
				
				var data = {
					field0: $('input[name="form-title"]', form).val(),
					fieldName0: 'program',
					type: $('input[name="form-type"]', form).val()
				};
				
				$('.mentoring-sponsored-input:not(.no-check), .mentoring-sponsored-form-fields-ctn', form).each(function (i) {
					var t = $(this);
					var value = '';
					var fieldName = '';
					
					if (t.hasClass('mentoring-sponsored-form-fields-ctn')) {
						fieldName = $('.mentoring-sponsored-input-title', t).text();
						$('.mentoring-sponsored-check-input:checked', t).each(function () {
							if(value !== '') {
								value += ',';
							}
							value += $(this).val();
						});
					} else if (t.hasClass('mentoring-sponsored-select-multiple-input')) {
						value = t.val();
						fieldName = t.closest('.mentoring-sponsored-select-multiple').find('.mentoring-sponsored-select-multiple-label').text();
					} else if (t.attr('name') === 'email' || t.attr('name') === 'email-conf') {
						data['email'] = t.val();
					} else {
						value = t.val();
						fieldName = t.closest('.mentoring-sponsored-input-ctn').find('.mentoring-sponsored-input-label').text();
					}
					
					data['field'+(i+1)] = value;
					data['fieldName'+(i+1)] = fieldName;
				});
				
				//console.log(data);
				
				$.ajax({
					url: '/action/pmiMentorat',
					cache: false,
					data: data,
					method: 'POST',
					success: function (response) {
						var tokens = {
							'field1': form.find('input[name="name"]').val()
						};
						utils.sendEmail(form.find('.js-email').val(), form.closest('.mentoring').attr('data-email-subject'), null, 'mentoring-form-sent-' + $('html').attr('lang'), tokens, function(response) {
							//console.log(response);
						});
					}
				});
				
				var ctn = form.closest('.mentoring-sponsored-step');
				var goto = $(this).attr('data-go-to');
				var gotoCtn = $('.mentoring-sponsored-step[data-step="'+goto+'"]', form.closest('.mentoring-content'));
				var from = $('.mentoring-question-prev-btn', ctn).attr('data-go-to');
				gotoStep($(this), goto, function () {
					$('.mentoring-question-prev-btn', gotoCtn).attr('data-go-to', from);
				});
			} else {
				$('.mentoring-form-error-msg', form).slideDown(200);
			}
		});
		
		$('.mentoring-sponsored-step-form-submit, .mentoring-question-answer-btn').click(function () {
			var t = $(this);
			var ctn = t.closest('.mentoring-sponsored-step');
			var from = ctn.attr('data-step');
			var goto = t.attr('data-go-to');
			var bigCtn = ctn.closest('.mentoring-content');
			
			if (goto === undefined) {
				var currSelected = $('.mentoring-question-answer-btn.selected', ctn);
				
				if (currSelected.length !== 0) {
					goto = currSelected.attr('data-step');
				} else {
					var input = $('.mentoring-question-answer-input', ctn);
					
					if (input[0]) {
						if (!input.val() || input.val().trim() === '') {
							input.closest('.mentoring-sponsored-input-ctn').addClass('form-error');
							return false;
						} else {
							input.closest('.mentoring-sponsored-input-ctn').removeClass('form-error');
							goto = input.attr('step');
						}
					} else {
						$('.mentoring-question-answer-btn', ctn).addClass('form-error');
						return false;
					}
				}
			}
			
			var gotoCtn = $('.mentoring-sponsored-step[data-step="'+goto+'"]', bigCtn);
			gotoStep($(this), goto, function () {
				$('.mentoring-question-prev-btn', gotoCtn).attr('data-go-to', from);
			});
		});
		
		$('.mentoring-question-prev-btn').click(function () {
			var t = $(this);
			var goto = t.attr('data-go-to');
			
			gotoStep(t, goto);
		});
		
		function gotoStep(t, goto, callback) {
			var ctn = t.closest('.mentoring-sponsored-step');
			var from = ctn.attr('data-step');
			var bigCtn = ctn.closest('.mentoring-content');
			var gotoCtn = $('.mentoring-sponsored-step[data-step="'+goto+'"]', bigCtn);
			var target = $('.mentoring-nav').offset().top;
			
			if ($('.site-header').css('position') === 'fixed') {
				target -= parseInt($('.site-header').outerHeight());
				target -= parseInt($('.site-header').css('top'));
			}
			
			$('body, html').animate({scrollTop: target}, 400);
			
			ctn.fadeOut(200, function() {
				gotoCtn.fadeIn(200);
				
				if (typeof callback === 'function') {
					callback();
				}
			});
		}
		
		$('.mentoring-nav-btn').click(function () {
			var t = $(this);
			var cat = t.attr('data-cat');
			
			if (!t.hasClass('selected')) {
				$('.mentoring-nav-btn').removeClass('selected');
				t.addClass('selected');
				
				var target = $('.mentoring-nav').offset().top;
				
				if ($('.site-header').css('position') === 'fixed') {
					target -= parseInt($('.site-header').outerHeight());
					target -= parseInt($('.site-header').css('top'));
				}
				
				$('body, html').animate({scrollTop: target}, 400);
				
				$('.mentoring-content.selected').fadeOut(200, function () {
					$(this).removeClass('selected');
					
					$('.mentoring-content[data-id="'+cat+'"]').fadeIn(200, function () {
						$(this).addClass('selected');
					});
				});
			}
		});
		
		$('.mentoring-login-form-btn').click(function () {
			var t = $(this);
			
			$('.mentoring-login-form-btn').removeClass('selected');
			t.addClass('selected');
			
			if (t.attr('data-cat') === 'yes') {
				$('.mentoring-login-form').show();
				$('.mentoring-login-form-create-account').hide();
			} else {
				$('.mentoring-login-form').hide();
				$('.mentoring-login-form-create-account').show();
			}
		});
	};

  $(init);
})(jQuery);
